import React from 'react';
import { LinkButtonV3 } from 'Components/buttons/LinkButton/LinkButtonV3';
import { LOG_SOURCE_FILTERS_DOC_URL } from 'Source/constants';
import { Notification as NotificationType } from 'Generated/schema';
import { Flex, Button } from 'pounceV2';
import urls from 'Source/urls';
import { NotificationTitleEnum } from './constants';

const NotificationActionsV3 = ({ notification }: { notification: NotificationType }) => {
  switch (notification?.title) {
    case NotificationTitleEnum.INGESTION_CAPACITY_LIMIT:
    case NotificationTitleEnum.INGESTION_CAPACITY_LIMIT_REACHED:
      return (
        <Flex>
          <LinkButtonV3 variant="outline" external size="medium" to={LOG_SOURCE_FILTERS_DOC_URL}>
            Explore Filters
          </LinkButtonV3>
        </Flex>
      );

    // Leave this here as reference
    // Should be moved under case NotificationTitleEnum.SYSTEM_ERROR:
    case NotificationTitleEnum.SOURCE_NO_DATA:
      return (
        <Flex spacing={3} align="center">
          <Button variant="outline" size="medium">
            Manage Alarm
          </Button>
          <Button variant="secondary" size="medium">
            View Errors
          </Button>
        </Flex>
      );

    case NotificationTitleEnum.SYSTEM_ERROR:
      return !notification.metadata?.alertID ? null : (
        <Flex>
          <LinkButtonV3
            variant="primary"
            size="medium"
            to={urls.alerts.details(notification.metadata?.alertID)}
          >
            View Errors
          </LinkButtonV3>
        </Flex>
      );

    default:
      return null;
  }
};

export default NotificationActionsV3;
